import React, { FC } from "react";

import edit from "../../../assets/edit.svg";
import { IExpandedPreviewData } from "../../../common/interfaces/common.interface";
import "./PreviewComponent.scss";
interface PreviewItemData {
  title?: string;
  description?: number | string | Date;
  spanText?: string;
  additionalDescription?: string;
  expandedDescription?: IExpandedPreviewData[];
}

interface PreviewComponentProps {
  previewContent: PreviewItemData[];
  label: string;
  showEditIcon: boolean;
  editSection?: () => void;
}

const PreviewComponent: FC<PreviewComponentProps> = ({
  previewContent,
  label,
  showEditIcon,
  editSection,
}) => {
  return (
    <div className="preview-component">
      <div className="preview-component__header-wrapper">
        <p className="preview-component__title">{label}</p>
        {showEditIcon && (
          <img
            src={edit}
            className="preview-component__edit-icon"
            alt=""
            onClick={editSection}
          />
        )}
      </div>
      <div className="preview-component__content">
        <div className="preview-component__items">
          {previewContent.map((item, index) => {
            return (
              <div className="preview-component__item">
                <div className="preview-component__text" key={item.title}>
                  <p className="preview-component__text-title">{item.title}</p>
                  <div className="preview-component__text-description">
                    {item.description && (
                      <div>
                        <h4>
                          {item.description}{" "}
                          <span className="preview-component__span-text">
                            {item.spanText}
                          </span>
                        </h4>
                        <p className="preview-component__additional-description">
                          {item.additionalDescription}
                        </p>
                      </div>
                    )}
                    {item.expandedDescription &&
                      item.expandedDescription.map((description, index) => {
                        return (
                          <div className="preview-component__expanded-description-wrapper">
                            <div className="preview-component__expanded-description">
                              <p className="preview-component__label">
                                {description.label}
                                {description.spanText && (
                                  <span className="preview-component__description-span">
                                    {description.spanText}
                                  </span>
                                )}
                              </p>
                              <p className="preview-component__amount">
                                {description.amount}
                              </p>
                            </div>
                            {index < item.expandedDescription!.length! - 1 && (
                              <div className="preview-component__vertical-line"></div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PreviewComponent;
